import { render } from "./ProfileVideoHelp.vue?vue&type=template&id=131c5246&scoped=true"
import script from "./ProfileVideoHelp.vue?vue&type=script&lang=js"
export * from "./ProfileVideoHelp.vue?vue&type=script&lang=js"

import "./ProfileVideoHelp.vue?vue&type=style&index=0&id=131c5246&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-131c5246"]])

export default __exports__